export * from './aboutDogModal';

export const SurveyForm = {
  ContinueBtn: 'continue-btn',
};
